export const INFORMATIVE_MOBILE = {
    id: 1,
    logo: '../../../../assets/imgs/svg/tablet.svg',
    content: [
      {
        title: 'Confira como proteger seu celular e tablet!',
        subtitle: 'Dispositivos móveis são práticos, mas também alvos de golpes. Fique atento!',
        items: [
          '<b>Proteja seu dispositivo:</b> evite deixá-lo visível em locais públicos e use bloqueio de tela.',
          '<b>Cuidado com apps e links:</b> baixe apenas da loja oficial e desconfie de links desconhecidos.',
          '<b>Atenção ao Wi-Fi:</b> evite redes abertas e confirme a oficial com o local.',
          '<b>Atualizações e antivírus:</b> mantenha o celular atualizado e use um antivírus confiável.'
        ],
      },
      {
        title: 'Caiu no golpe? Não perca tempo, veja como agir',
        items: [
          '<b>Avise seu banco:</b> informe imediatamente sua instituição financeira.',
          '<b>Reforce sua segurança:</b> atualize senhas e tome medidas de proteção.',
          '<b>Procure as autoridades:</b> registre um Boletim de Ocorrência presencial ou eletrônico.'
        ]
      }
    ]
  };
  
  export const INFORMATIVE_ROBBERY = {
    id: 2,
    logo: '../../../../assets/imgs/svg/mobile.svg',
    content: [
      {
        title: 'Hoje, furtos miram mais os dados que o aparelho.',
        subtitle: 'Tenha cuidado com seus apps bancários, pois eles podem ser usados para transações indevidas, trazendo prejuízos.',
        items: [
          '<b>Proteja seu celular:</b> Use senhas fortes, mantenha o e-mail deslogado e redobre a atenção na rua.',
          '<b>Cuide dos apps bancários:</b> Evite usá-los em celulares de terceiros e proteja seus dados.',
          '<b>Anote seu IMEI:</b> Guarde o número de identificação do aparelho para facilitar registros de ocorrência.'
        ],
      },
      {
        title: 'Aconteceu com você? Não perca tempo, veja como agir.',
        items: [
          '<b>Bloqueie e resete:</b> Contate sua operadora para bloquear o IMEI e restaurar o aparelho remotamente.',
          '<b>Avise ao banco:</b> Informe sobre o roubo para proteger suas contas.',
          '<b>Aja com segurança:</b> Não tente recuperar o celular; acione a polícia caso consiga rastreá-lo.'
        ]
      }
    ]
  };
  
  export const INFORMATIVE_FAKE_CALL_CENTER = {
    id: 3,
    logo: '../../../../assets/imgs/svg/question-ballon.svg',
    content: [
      {
        title: 'Basta uma ligação bem-contada para cair no golpe.',
        subtitle: 'O golpista, se passando por funcionário do banco, usa um tom cordial e alarmista para falar de supostas movimentações suspeitas, como clonagem ou transações não reconhecidas. Com urgência, convence você a fornecer dados, que serão usados para limpar sua conta ou fazer compras com seu cartão.',
        items: [
          '<b>Proteja seus dados:</b> Não compartilhe informações pessoais nem clique em links suspeitos.',
          '<b>Desconfie de urgências:</b> Bancos nunca pedem dados por telefone.',
          '<b>Aja com cautela:</b> Se achar a ligação estranha, desligue imediatamente.'
        ],
      },
      {
        title: 'Aconteceu com você?',
        items: [
          '<b>Avise ao banco:</b> Use os canais oficiais para bloquear serviços e contas.',
          '<b>Registre o caso:</b> Faça uma reclamação com a empresa envolvida.',
          '<b>Denuncie:</b> Informe a tentativa de golpe às autoridades competentes.'
        ]
      }
    ]
  };
  
  export const INFORMATIVE_WHATSAPP_SCAM = {
    id: 4,
    logo: '../../../../assets/imgs/svg/whatsapp.svg',
    content: [
      {
        title: 'Criminosos usam truques para enganar e colocar você e seus contatos em risco.',
        subtitle: 'Eles podem se passar por funcionários de empresas e pedir o código de verificação do WhatsApp, clonando sua conta e pedindo dinheiro. Outra tática é criar perfis falsos de amigos, fingindo emergências para pedir transferências.',
        items: [
          '<b>Ative a segurança:</b> Use a verificação em duas etapas no WhatsApp e instale um antivírus confiável.',
          '<b>Cuidado com mensagens:</b> Nunca forneça códigos recebidos por SMS ou clique em links suspeitos.',
          '<b>Verifique informações:</b> Confirme qualquer dúvida pelos canais oficiais.'
        ],
      },
      {
        title: 'Aconteceu com você? Não perca tempo, veja como agir.',
        items: [
          '<b>Informe o dono da conta imediatamente.</b>',
          '<b>Registre um boletim de ocorrência com prints do perfil e conversas.</b>',
          '<b>Contacte o banco se já tiver transferido dinheiro para tentar bloquear o valor.</b>'
        ]
      }
    ]
  };


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/fraud-awareness-banner/fraud-awarenned-banner-bottom-sheet/informative-texts.ts